import React, { useState, useEffect, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes, faTag } from "@fortawesome/free-solid-svg-icons";
import "./styles/HoverDropdown.css";

function HoverDropdown({
  downloadTxtFile,
  text,
  handleTitleChange,
  exportfeatures,
  handleTabChange,
  setSelectedWeights,
  handleExportTypeChange,
  handleSelection,
  feature,
}) {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    if (!isDropdownOpen) return;
    const handleClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isDropdownOpen]);

  const toggle = () => setIsDropdownOpen((v) => !v);
  const close = () => setIsDropdownOpen(false);

  const onSelection = (value, displayText) => {
    if (feature === 1) {
      downloadTxtFile(value);
    } else if (feature === 2) {
      handleTabChange(value);
    } else if (feature === 3) {
      setSelectedWeights(value);
    } else if (feature === 4) {
      handleExportTypeChange(value);
    } else if (feature === 5) {
      handleTitleChange("type", displayText);
    } else if (feature === 6 && handleSelection) {
      handleSelection(displayText);
    }
    close();
  };

  return (
    <div ref={containerRef} className="hover-dropdown">
      <span
        className={`hover-text${isDropdownOpen ? " hover-text--active" : ""}`}
        onClick={toggle}
      >
        {text}
      </span>

      {isDropdownOpen && (
        <div className="dropdown-menu">
          <div className="hover-dropdown-header">
            <div className="hover-dropdown-header-left">
              <FontAwesomeIcon icon={faTag} className="hover-dropdown-icon" />
              <span className="hover-dropdown-title">{text}</span>
            </div>
            <div className="hover-dropdown-header-right">
              <button className="hover-dropdown-close" onClick={close} title="Close">
                <FontAwesomeIcon icon={faTimes} />
              </button>
            </div>
          </div>

          {feature === 1 && exportfeatures?.map((x, index) => (
            <div key={index} className="dropdown-item" onClick={() => onSelection(x.type, x.text)}>
              {x.text}
            </div>
          ))}

          {feature === 2 && exportfeatures?.map((x, index) => (
            <div key={index} className="dropdown-item" onClick={() => onSelection(x.name, x.name)}>
              {x.name}
            </div>
          ))}

          {feature === 3 && exportfeatures && Object.keys(exportfeatures).map((x, index) => (
            <div key={index} className="dropdown-item" onClick={() => onSelection(x, x)}>
              {x}
            </div>
          ))}

          {feature === 4 && exportfeatures?.map((x, index) => (
            <div key={index} className="dropdown-item" onClick={() => onSelection(x.value, x.text)}>
              {x.text}
            </div>
          ))}

          {feature === 5 && exportfeatures?.map((x, index) => (
            <div key={index} className="dropdown-item" onClick={() => onSelection(x.text, x.text)}>
              {x.text}
            </div>
          ))}

          {feature === 6 && exportfeatures?.map((featureItem, index) => (
            <div key={index} className="dropdown-item" onClick={() => handleSelection(featureItem.value)}>
              {featureItem.label || featureItem.value}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default HoverDropdown;
